module.exports = __webpack_public_path__ + "img/gaoxiaodezhudongyingxiao.3253d4f8.png";